"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LessonStatus = void 0;
var LessonStatus;
(function (LessonStatus) {
    LessonStatus[LessonStatus["linkedToPublished"] = 0] = "linkedToPublished";
    LessonStatus[LessonStatus["linkedToUnpublished"] = 1] = "linkedToUnpublished";
    LessonStatus[LessonStatus["unlinked"] = 2] = "unlinked";
})(LessonStatus = exports.LessonStatus || (exports.LessonStatus = {}));
